import { Heart, Car } from "lucide-react";
import { Separator } from "@/components/ui/separator";

export const InvoiceFooter = ({ companyInfo }) => {
  return (
    <div className="space-y-6 pt-6">
      <Separator />

      {/* Thank You Message */}
      <div className="text-center space-y-3">
        <div className="flex items-center justify-center gap-2 text-primary">
          <Heart className="w-4 h-4" />
          <span className="text-sm font-medium">Thank you for your business!</span>
          <Heart className="w-4 h-4" />
        </div>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          We appreciate your trust in {companyInfo.name}. If you have any questions 
          about this invoice, please don&apos;t hesitate to contact us.
        </p>
      </div>

      {/* Company Footer */}
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-4 border-t border-border">
        <div className="flex items-center gap-2 text-muted-foreground">
          <div className="flex items-center justify-center w-6 h-6 rounded bg-muted">
            <Car className="w-3.5 h-3.5 text-muted-foreground" />
          </div>
          <span className="text-xs">
            {companyInfo.name}
          </span>
        </div>

        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          <span>{companyInfo.phone}</span>
          <span>•</span>
          <span>{companyInfo.email}</span>
        </div>
      </div>

      {/* Legal Notice */}
      <p className="text-center text-xs text-muted-foreground/70">
        This invoice was generated electronically and is valid without signature.
      </p>
    </div>
  );
};
